import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartItem } from '../../models/cart-item.model';
import { AddToCartRequest, CartItemDto } from '../../models/add-to-cart-request.model';
import { CartService } from '../../services/cart.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  cartItems: CartItem[] = [];
  totalAmount: number = 0;
  environment = environment;

  constructor(
    private cartService: CartService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCartItems();
  }

  loadCartItems(): void {


    this.cartService.getCartItems().subscribe({
      next: (cart) => {
        this.cartItems = cart.items;
        this.calculateTotal();
        this.cartService.refreshCartCount(); // Refresh cart count
      },
      error: (err) => {
        console.error('Error loading cart items:', err);
      }
    });
  }

  calculateTotal(): void {

    if (!Array.isArray(this.cartItems)) {
      console.warn('cartItems is not an array:', this.cartItems);
      this.totalAmount = 0;
      return;
    }

    this.totalAmount = this.cartItems.reduce(
      (sum, item) => sum + (item.product.price * item.quantity),
      0
    );
  }

  //updateQuantity(item: CartItem, newQty: number): void {
  //  if (newQty < 1) return;

  //  this.cartService.updateCartItem(item.productId, newQty).subscribe({
  //    next: () => {
  //      item.quantity = newQty;
  //      this.calculateTotal();
  //    },
  //    error: (err) => console.error('Failed to update quantity:', err)
  //  });
  //}

  updateQuantity(productId: number, newQuantity: number): void {
    this.cartService.updateCartItem(productId, newQuantity).subscribe({
      next: res => {
        console.log('Cart item updated successfully', res);
        this.loadCartItems(); // Refresh cart
      },
      error: err => {
        console.error('Error updating cart item', err);
      }
    });
  }

  removeItem(productId: number): void {
    this.cartService.removeCartItem(productId).subscribe({
      next: () => {
        this.cartItems = this.cartItems.filter(item => item.productId !== productId);
        this.calculateTotal();
        this.loadCartItems(); // Refresh cart
      },
      error: (err) => console.error('Failed to remove item:', err)
    });
  }

  checkout(): void {
    if (this.cartItems.length === 0) {
      alert('Your cart is empty. Please add items to your cart before checking out.');
      return;
    }
    else if (!localStorage.getItem('userId')) {
      alert('You must be logged in to checkout. Please log in first.');
      return;
    }
    else if (this.cartItems.some(item => item.quantity <= 0)) {
      alert('All items must have a quantity greater than zero before checking out.');
      return;
    }
    else if (this.cartItems.some(item => !item.size)) {
      alert('All items must have a size selected before checking out.');
      return;
    }
    else {
      this.router.navigate(['/checkout']);
    }

    //this.cartService.placeOrder().subscribe({
    //  next: () => {
    //    alert('Order placed successfully!');
    //    this.router.navigate(['/product/GetAll']);
    //  },
    //  error: (err) => {
    //    console.error('Checkout failed:', err);
    //    alert('Checkout failed. Please try again.');
    //  }
    //});
  }

  addAnotherSize(item: any) {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      alert('User not logged in. Please login first.');
      return;
    }
    //const newItem = {
    //  productId: item.productId,
    //  size: item.size === 'M' ? 'L' : 'M', // Example logic
    //  quantity: 1
    //};

    const cartItem: CartItemDto = {
      productId: item.productId,
      quantity: item.quantity,
      price: item.price,
      size: item.size
    };

    const newItem: AddToCartRequest = {
      userId: userId,
      items: [cartItem]
    };

    this.cartService.addToCart(newItem);

    //this.cartService.addToCart(newItem).subscribe({
    //  next: (res) => {
    //    console.log('New size added:', res);
    //    this.loadCartItems(); // refresh cart
    //  },
    //  error: (err) => {
    //    console.error('Failed to add another size', err);
    //  }
    //});
  }

  //placeOrder() {
  //  this.cartService.placeOrder().subscribe({
  //    next: (res) => {
  //      console.log('Order placed:', res);
  //      alert('Your order has been placed successfully!');
  //      this.cartItems = []; // clear local cart
  //    },
  //    error: (err) => {
  //      console.error('Failed to place order:', err);
  //      alert('Order failed. Please try again.');
  //    }
  //  });
  //}
}


